module.exports = __webpack_public_path__ + "static/media/IMG4.3d7c4b8d.png";